// HeaderJS config
window.pkHeaderData = { responsiveBreakpoint: 992 };

import '@pk-theme/header.js';
import '@pk-theme/dialogs.js';